import { memo } from 'react'
import { Typography, TypographyProps } from '@mui/material'

export interface TextProps extends TypographyProps {}

function Text(props: TextProps) {
  return <Typography {...props} />
}

export default memo(Text)
